<template>
  <div class="admin-order-create">
    <div class="header-toolbar">
      <h2>{{ isEdit ? '编辑订单' : '新增订单' }}</h2>
      <el-button type="info" @click="goBack">返回订单列表</el-button>
    </div>

    <div class="form-container" style="width: 80%; margin: 20px auto; padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
      <el-form :model="orderForm" :rules="orderRules" ref="orderFormRef" label-width="120px">
        <!-- 客户编号 -->
        <el-form-item label="客户编号" prop="customerNo">
          <el-input v-model="orderForm.customerNo" placeholder="请输入客户编号"></el-input>
        </el-form-item>

        <!-- PO号 -->
        <el-form-item label="PO号" prop="poNo">
          <el-input v-model="orderForm.poNo" placeholder="请输入PO号"></el-input>
        </el-form-item>

        <!-- PI号 -->
        <el-form-item label="PI号" prop="piNo">
          <el-input v-model="orderForm.piNo" placeholder="请输入PI号"></el-input>
        </el-form-item>

        <!-- MVB产品型号 -->
        <el-form-item label="MVB产品型号" prop="mvbProductModel">
          <el-input v-model="orderForm.mvbProductModel" placeholder="请输入MVB产品型号"></el-input>
        </el-form-item>

        <!-- 产品型号 -->
        <el-form-item label="产品型号" prop="productModel">
          <el-input v-model="orderForm.productModel" placeholder="请输入产品型号"></el-input>
        </el-form-item>

        <!-- 产品代码 -->
        <el-form-item label="产品代码" prop="productCode">
          <el-input v-model="orderForm.productCode" placeholder="请输入产品代码"></el-input>
        </el-form-item>

        <!-- 条形码 -->
        <el-form-item label="条形码" prop="barcode">
          <el-input v-model="orderForm.barcode" placeholder="请输入条形码"></el-input>
        </el-form-item>

        <!-- 订单数量 -->
        <el-form-item label="订单数量" prop="orderQuantity">
          <el-input v-model.number="orderForm.orderQuantity" type="number" placeholder="请输入订单数量"></el-input>
        </el-form-item>

        <!-- 已完成数量 -->
        <el-form-item label="已完成数量" prop="completedQuantity">
          <el-input v-model="orderForm.completedQuantity" type="number" placeholder="请输入已完成数量"></el-input>
        </el-form-item>

        <!-- 预计交期 -->
        <el-form-item label="预计交期" prop="estimatedDeliveryDate">
          <el-date-picker v-model="orderForm.estimatedDeliveryDate" type="date" placeholder="选择预计交期"></el-date-picker>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注">
          <el-input v-model="orderForm.remark" type="textarea" :rows="3" placeholder="请输入备注（可选）"></el-input>
        </el-form-item>

        <!-- 提交/取消按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm" style="margin-left: 10px;">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { saveOrUpdateOrder, adminGetOrderById } from '@/api/order' // 导入新增/回显接口
import { Message } from 'element-ui'

export default {
  name: 'AdminOrderCreate',
  data() {
    return {
      orderForm: {
        id: '', // 订单ID（编辑时必填）
        customerNo: '',
        poNo: '',
        piNo: '',
        mvbProductModel: '',
        productModel: '',
        productCode: '',
        barcode: '',
        orderQuantity: 0,
        completedQuantity: 0,
        estimatedDeliveryDate: '',
        remark: ''
      },
      orderRules: {
        customerNo: [{ required: true, message: '请输入客户编号', trigger: 'blur' }],
        piNo: [{ required: true, message: '请输入PI号', trigger: 'blur' }],
        productModel: [{ required: true, message: '请输入产品型号', trigger: 'blur' }],
        orderQuantity: [{ required: true, message: '请输入订单数量', trigger: 'blur', type: 'number' }]
      },
      isEdit: false, // 是否为编辑模式
      orderFormRef: null // 表单引用
    }
  },
  created() {
    // 🔥 关键：获取编辑传过来的id（路由query中的id）
    const orderId = this.$route.query.id;
    if (orderId) {
      this.isEdit = true;
      this.getOrderDetail(orderId); // 加载订单详情
    }
  },
  methods: {
    // 返回订单列表
    goBack() {
      this.$router.push('/admin-order-list');
    },

    // 🔥 编辑核心：获取订单详情回显
    getOrderDetail(id) {
      adminGetOrderById(id)
        .then(res => {
          if (res.code === 200 && res.data) {
            // 回显数据（字段名与后端返回一致）
            this.orderForm = {
              id: res.data.id,
              customerNo: res.data.customerNo,
              poNo: res.data.poNo,
              piNo: res.data.piNo,
              mvbProductModel: res.data.mvbProductModel,
              productModel: res.data.productModel,
              productCode: res.data.productCode,
              barcode: res.data.barcode,
              orderQuantity: res.data.orderQuantity,
              completedQuantity: res.data.completedQuantity,
              estimatedDeliveryDate: res.data.estimatedDeliveryDate,
              remark: res.data.remark || ''
            };
          } else {
            Message.error('获取订单详情失败');
            this.goBack();
          }
        })
        .catch(err => {
          console.error('获取订单详情异常:', err);
          Message.error('获取订单详情失败');
          this.goBack();
        });
    },

    // 提交表单（新增/编辑统一处理）
    submitForm() {
      this.$refs.orderFormRef.validate((isValid) => {
        if (isValid) {
          saveOrUpdateOrder(this.orderForm)
            .then(res => {
              if (res.code === 200) {
                Message.success(this.isEdit ? '订单编辑成功' : '订单新增成功');
                this.goBack(); // 跳转回列表页
              } else {
                Message.error(res.msg || (this.isEdit ? '订单编辑失败' : '订单新增失败'));
              }
            })
            .catch(err => {
              console.error('提交订单异常:', err);
              Message.error(this.isEdit ? '订单编辑失败' : '订单新增失败');
            });
        } else {
          Message.warning('请完善必填字段');
          return false;
        }
      });
    },

    // 重置表单
    resetForm() {
      this.$refs.orderFormRef.resetFields();
      // 编辑模式不重置id
      if (!this.isEdit) {
        this.orderForm.id = '';
      }
    }
  }
}
</script>

<style scoped>
.admin-order-create {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.header-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
</style>